<template>
	<div>
		<template v-if="textoTooltip">
			<v-tooltip max-width="800" bottom color="black">
				<template #activator="{ on, attrs }">
					<span v-bind="attrs" v-on="on" :style="{ color: colorText }">
						<span>{{ texto }}</span>
					</span>
				</template>
				<span>{{ textoTooltip }}</span>
			</v-tooltip>
		</template>

		<template v-else>
			<v-tooltip max-width="800" v-if="validarTamanhoMaximoTexto()" bottom color="black">
				<template #activator="{ on, attrs }">
					<span v-bind="attrs" v-on="on" :style="{ color: colorText }">
						{{ tratarTextoParaSerMenor() }}
					</span>
				</template>
				<span style="word-break: break-word; overflow-wrap: break-word;">{{ texto }}</span>
			</v-tooltip>
			<span :style="{ color: colorText }" v-else>{{ texto ? texto : mensagemTextoVazio }}</span>
		</template>
	</div>
</template>

<script>
export default {
	name: 'texto-tooltip',
	props: {
		texto: {
			type: String,
			default: '',
		},
		mensagemTextoVazio: {
			type: String,
			default: '',
		},
		tamanhoMaximo: {
			type: Number,
			default: 10,
		},
		colorButton: {
			type: String,
			default: 'primary',
		},
		colorText: {
			type: String,
			default: 'primary',
		},
		textoTooltip: {
			type: String,
			default: null,
		},
	},
	methods: {
		tratarTextoParaSerMenor() {
			if (this.validarTamanhoMaximoTexto()) {
				return this.texto.substring(0, this.tamanhoMaximo).concat('...')
			}
			return this.texto
		},
		validarTamanhoMaximoTexto() {
			return this.texto && this.texto.length > this.tamanhoMaximo
		},
	},
}
</script>

<style lang="stylus" scoped></style>
